<template>
  <div v-if="loading">
    <loader></loader>
  </div>
  <div v-else>
    <div class="row">
      <h1>Convidar</h1>
      <hr/>
    </div>
    <div class="row">
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <div v-if="ownerEditInvite">
          <div class="alert alert-info">
            O requisitante será notificado. <b>Ele poderá modificar as informações do formulário.</b>
          </div>
        </div>
        <div v-else>
          <p>Selecione um usuário abaixo. Um email será enviado para formalizar o convite.</p>
          <div class="users-table">
            <div class="col-sm-1" >
              <select class="input-sm" v-model="perPage" @change="getUsers">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-9"></div>
            <div class="col-sm-2">
              <b-form-input v-model="filter" @keyup.enter="getUsers" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
            <b-table :items="users" :fields="userFields" class="users-table" striped hover>
              <div slot="select" slot-scope="item" class="text-center">
                <input v-model="invite.users" :value="item.item" type="checkbox" />
              </div>
              <ul slot="tags" slot-scope="item" class="list-inline">
                <li v-for="tag in item.value"><span class="label label-primary text-capitalize">{{ tag }}</span></li>
              </ul>
            </b-table>
            <b-pagination size="sm" :total-rows="usersCount" :per-page="perPage" v-model="currentPage" @input="getUsers" style="z-index:0" />
          </div>
        </div>
        <div class="form-group">
          <label for="canComment">Pode comentar?</label>
          <input type="checkbox" id="canComment" v-model="invite.canComment"/>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <label for="expires">Expira?</label>
            <div class="input-group">
              <span class="input-group-addon">
                <input type="checkbox" id="expires" v-model="invite.expires"/>
              </span>
              <masked-input :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]" :guide="false"
                v-model="invite.expiration" :disabled="!invite.expires" class="form-control" />
            </div>
          </div>
          <div class="col-xs-6">
            <label for="advanced">Informações Compartilhadas</label>
            <multiselect v-model="invite.sharedFields" :options="fields" :multiple="true"
              :close-on-select="false" :clear-on-select="false" :hide-selected="true"
              placeholder="Se não especificado, todos campos serão visíveis" label="name" track-by="objectId"></multiselect>
          </div>
        </div>
        <br/>
        <div class="form-group">
          <label for="inviteEmailText">Texto do Email de Convites</label>
          <quill-editor id="inviteEmailText" v-model="emailText"
                    :config="editorConfig" class="comment_editor">
          </quill-editor>
          <p class="text-muted">Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.</p>
        </div>
        <div class="btn-container">
          <button class="btn btn-default" @click="$router.go('-1')">Voltar</button>
          <button slot="footer" id="btn-confirm" class="btn btn-primary" @click="save">Convidar</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>

import MaskedInput from 'vue-text-mask'
import Loader from './util/Loader'
import moment from 'moment'
import { quillEditor } from 'vue-quill-editor'
import Multiselect from 'vue-multiselect'
import { Parse, miniToastr } from '../Global'
import { PUBLIC_URL } from '../../config/prod.env'
import { handleParseError } from './util/ErrorHandling'
moment.locale('pt-br')

var publicURL = JSON.parse(PUBLIC_URL)

export default {
  components: {
    Loader,
    Multiselect,
    quillEditor,
    MaskedInput
  },
  data () {
    return {
      loading: false,
      userFields: {
        select: { label: 'Selecione' },
        name: { label: 'Nome', sortable: true },
        email: { label: 'Email', sortable: true },
        count: { label: 'Total Convites', sortable: true },
        tags: { label: 'Dados' }
      },
      ownerEditInvite: false,
      invite: {canEdit: false, expires: false, canComment: true, users: [], sharedFields: [], expiration: null},
      currentPage: 1,
      perPage: 5,
      filter: null,
      users: [],
      usersCount: 0,
      fields: [],
      request: null,
      step: null,
      emailText: `
          </br>
          <p><strong>Siga os seguintes passos acessar o Sistema:</strong></p>
          <p><strong style="color:rgb(230,0,0)">1) Acesse a página das Requisições:</strong></p>
          <p>Acesse o sistema de submissão eletrônica, através da URL <a href="${publicURL}/#/?next=/userProfile?tb=invites" target="_blank">${publicURL}/#/?next=/userProfile?tb=invites</a>.</p>
          <p><strong style="color:rgb(230,0,0)">2) Caso seja seu primeiro acesso ou não lembre da senha:</strong></p>
          <p>Para obter sua senha de acesso, informe seu e-mail na página <a href="${publicURL}/#/password-reset" target="_blank">${publicURL}/#/password-reset</a></p>
      `,
      editorConfig: {
        placeholder: '',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image']
          ]
        }
      }
    }
  },
  mounted () {
    let requestId = this.$route.params.requestId
    let stepId = this.$route.params.stepId
    this.ownerEditInvite = this.$route.query.ownerEditInvite === 'true'
    this.invite.canEdit = this.ownerEditInvite
    this.load(requestId, stepId)
  },
  methods: {
    /**
    * Carrega de forma assíncrona informações adicionais sobre o Request e o Step em questão (nome etc.)
    **/
    load (requestId, stepId) {
      let self = this
      self.loading = true
      let params = {
        requestId: requestId,
        stepId: stepId
      }
      Parse.Cloud.run('requestInviteInfo', params).then(results => {
        self.request = results.request
        self.step = results.step
        self.fields = results.fields
        self.invite.sharedFields = results.sharedFields
        params = {
          currentPage: self.currentPage,
          perPage: self.perPage,
          filter: self.filter,
          workflowId: self.request.workflow.id
        }
        if (self.request.workflow) {
          let customizations = self.request.workflow.get('customizations')
          if (customizations.inviteEmail) {
            self.emailText = customizations.inviteEmail + self.emailText
          }
        }
        if (self.ownerEditInvite) {
          self.invite.users = [self.request.owner.toJSON()]
        }
        return Parse.Cloud.run('listInviteUsers', params)
      }).then(results => {
        self.loading = false
        self.users = results.users
        self.usersCount = results.count
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    getUsers () {
      let self = this
      self.loading = true
      let params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.request.workflow.id
      }
      Parse.Cloud.run('listInviteUsers', params).then(results => {
        self.users = results.users
        self.usersCount = results.count
        self.loading = false
      }).fail(error => {
        handleParseError(self, error)
        self.modalLoading = false
      })
    },
    /**
    * Salva um novo convite
    **/
    save () {
      let self = this
      let invalid = false
      if (!self.invite.users.length) {
        miniToastr.warn('Selecione ao menos um usuário.')
        invalid = true
      }
      if (self.invite.expires) {
        if (!self.invite.expiration) {
          miniToastr.warn('Informe a data de expiração.')
          invalid = true
        } else if (!moment(self.invite.expiration, 'DD-MM-YYYY').isValid()) {
          miniToastr.warn('Informe uma data válida.')
          invalid = true
        }
      }
      if (!self.emailText || !self.emailText.trim()) {
        miniToastr.warn('Preencha o corpo da mensagem de e-mail.')
        invalid = true
      }
      if (invalid) {
        return
      }
      if (self.invite.expiration) {
        self.invite.expiration = moment(self.invite.expiration, 'DD-MM-YYYY')
          .endOf('day')
          .toDate()
      }
      let params = {
        requestId: self.request.objectId,
        stepId: self.step.objectId,
        invite: self.invite,
        emailText: self.emailText
      }
      Parse.Cloud.run('saveInvites', params).then(() => {
        miniToastr.success('Salvo com sucesso.')
        self.$router.go('-1')
      }).fail(error => {
        console.log(error)
        miniToastr.error('Ocorreu um erro durante a operação')
      }).always(() => {
        self.invite = { expires: false, canComment: true, users: [], sharedFields: [] }
        self.loading = false
        self.showModal = false
        self.load(self.request.objectId, self.step.objectId)
      })
    }
  }
}
</script>

<style scoped>
.users-table, .btn-container {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// RequestInviteSelect.vue?498fbab4